import React, { FC, useContext } from 'react'

import { Container, Row, Col } from '@mch-group/uikit-components'
import { Text } from '@components'
import { PageContext } from '@providers/PageContext'
import classNames from 'classnames'

const EMVideoCreditSection: FC<IEMVideoCreditSection> = ({ id, emvcs_video_info, emvcs_video_description }) => {
  const { page: { siteLanguage } } = useContext(PageContext)
  return (
    <section
      className={classNames('em-video-credit-section', siteLanguage === 'zh_CN' ?
        'mb-7 mb-md-8' : 'mb-9 mb-md-12')}
      id={id}>
      <Container className='px-5 px-lg-8 px-md-7'>
        <Row gutter='g-5 g-md-6 g-xl-7' className='justify-content-lg-center my-0 py-0'>
          <Col xs={12} md={10} lg={5} xl={4} className='my-0 py-0 order-2 order-lg-1 offset-md-1 offset-lg-0 me-xxl-3'>
            <Text className='text-medium video-text mt-9 mt-lg-0' isHtml>{emvcs_video_info}</Text>
          </Col>
          <Col xs={12} md={10} lg={5} xl={6} className='my-0 py-0 order-1 order-lg-2 offset-md-1 offset-lg-0'>
            <Text className='text-medium' isHtml>{emvcs_video_description}</Text>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

interface IEMVideoCreditSection {
  [key: string]: string
}

export default EMVideoCreditSection
